import { createReducer } from '@reduxjs/toolkit';
import { setIsModalShowed, setIsModalHide, setSelectedDealerIdModalData } from './actions';
const initialState = {
    type: null,
};
export const reducer = createReducer(initialState, (builder) => {
    builder
        .addCase(setIsModalShowed, (_, { payload: { type, data } }) => ({
        type,
        data,
    }))
        .addCase(setIsModalHide, () => initialState)
        .addCase(setSelectedDealerIdModalData, (state, { payload }) => ({
        ...state,
        data: {
            ...state.data,
            selectedDealerId: payload,
        },
    }));
});
